module.exports = __webpack_public_path__ + "static/media/partners.eddb5be8.png";